import * as React from "react"
const Upload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M6.604 20c-.55 0-1.021-.196-1.413-.588A1.922 1.922 0 0 1 4.604 18v-3h2v3h12v-3h2v3c0 .55-.196 1.021-.588 1.413a1.922 1.922 0 0 1-1.412.587h-12Zm5-4V7.85l-2.6 2.6L7.604 9l5-5 5 5-1.4 1.45-2.6-2.6V16h-2Z"
    />
  </svg>
)
export default Upload